/**
 * Dark gradient shell for join / invite full-screen layouts (loading, errors, cards).
 */

import { useMemo, type ReactNode } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { useTheme } from '../../theme/useTheme';
import { getJoinDeepLinkStyles } from '../../../appStyles/_joinDeepLink.styles';
import { getJoinFlowGradientColors } from '../helpers/joinFlowScreen.helper';

interface JoinFlowScreenProps {
  children: ReactNode;
  variant?: 'loading' | 'content';
}

export function JoinFlowScreen({ children, variant = 'content' }: JoinFlowScreenProps) {
  const appTheme = useTheme();
  const styles = useMemo(() => getJoinDeepLinkStyles(appTheme), [appTheme]);
  const gradient = useMemo(() => getJoinFlowGradientColors(appTheme), [appTheme]);
  const containerStyle = variant === 'loading' ? styles.loadingContainer : styles.gradient;

  return (
    <LinearGradient colors={gradient} style={containerStyle}>
      {children}
    </LinearGradient>
  );
}
